/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCallSessionDto
 */
export interface UpdateCallSessionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCallSessionDto
     */
    status?: string | null;
}

/**
 * Check if a given object implements the UpdateCallSessionDto interface.
 */
export function instanceOfUpdateCallSessionDto(value: object): value is UpdateCallSessionDto {
    return true;
}

export function UpdateCallSessionDtoFromJSON(json: any): UpdateCallSessionDto {
    return UpdateCallSessionDtoFromJSONTyped(json, false);
}

export function UpdateCallSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCallSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UpdateCallSessionDtoToJSON(json: any): UpdateCallSessionDto {
    return UpdateCallSessionDtoToJSONTyped(json, false);
}

export function UpdateCallSessionDtoToJSONTyped(value?: UpdateCallSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

